export default __webpack_public_path__ + "static/kargo-3edb953258a4f0adfab6dd20d75cedb4.svg";